import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { msalInstance } from '../msalConfig';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// This page handles the Microsoft redirect callback.
// It's used as a fallback redirect URI — if MSAL lands here, it processes the auth
// code and redirects to the correct dashboard.
export default function AuthPopupPage() {
  const navigate = useNavigate();

  useEffect(() => {
    // Dynamically import loginWithToken from context to avoid circular deps
    const processAuth = async () => {
      try {
        await msalInstance.initialize();
        const response = await msalInstance.handleRedirectPromise();

        if (response && response.accessToken) {
          const res = await fetch(`${API_URL}/api/auth/sso/msal-token`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ access_token: response.accessToken }),
          });
          const data = await res.json();
          if (data.access_token) {
            localStorage.setItem('valoriza_token', data.access_token);
            const role = data.user?.role;
            if (role === 'admin') navigate('/admin');
            else if (role === 'manager') navigate('/manager');
            else navigate('/portal');
          } else {
            navigate('/login?sso_error=' + encodeURIComponent(data.detail || 'Error SSO'));
          }
        } else {
          navigate('/login');
        }
      } catch (e) {
        console.error('MSAL auth/popup error:', e);
        navigate('/login?sso_error=' + encodeURIComponent('Error técnico de autenticación'));
      }
    };

    processAuth();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-3 text-muted-foreground">
        <span className="h-6 w-6 border-2 border-current border-t-transparent rounded-full animate-spin" />
        <span className="text-sm">Autenticando con Microsoft...</span>
      </div>
    </div>
  );
}
